import { render } from "./PageAuth.vue?vue&type=template&id=6cfa9108&scoped=true"
import script from "./PageAuth.vue?vue&type=script&lang=js"
export * from "./PageAuth.vue?vue&type=script&lang=js"

import "./PageAuth.vue?vue&type=style&index=0&id=6cfa9108&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cfa9108"]])

export default __exports__